import { render } from "./VerifyEmailDialog.vue?vue&type=template&id=2aaedb83&scoped=true"
import script from "./VerifyEmailDialog.vue?vue&type=script&lang=js"
export * from "./VerifyEmailDialog.vue?vue&type=script&lang=js"

import "./VerifyEmailDialog.vue?vue&type=style&index=0&id=2aaedb83&lang=scss&scoped=true"
import "./VerifyEmailDialog.vue?vue&type=style&index=1&id=2aaedb83&lang=scss"
script.render = render
script.__scopeId = "data-v-2aaedb83"

export default script